import {Component, Input, OnInit} from '@angular/core';
import {Help} from '../help';
import {HelpService} from '../help.service';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent {
  @Input() help: Help;

  constructor(private helpService: HelpService) {
  }

  excluirHelp(codigo: number) {
    if (confirm('Deseja realmente Excluir a Pergunta?')) {

      this.helpService.deleteHelp(codigo).subscribe(data => {
        if (data.success) {
          this.help = null;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/help/lista/lista.component.ts